<template>
    <app-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-gray-800">Projektid</h2>
        </template>

        <div class="py-12">
            <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div class="p-6 overflow-hidden bg-white shadow sm:rounded">

                  <DataTable :value="projects" :expandedRows.sync="expandedRows" :loading="loading" dataKey="id" responsiveLayout="scroll"
                             @row-expand="onRowExpand">
                    <Column :expander="true" :headerStyle="{'width': '3rem'}" />
                    <Column field="number" headerStyle="width:9%" header="Number" sortable>
                      <template #body="slotProps">
                        {{ slotProps.data.number }}
                      </template>
                    </Column>
                    <Column field="address" header="Aadress" sortable>
                      <template #body="slotProps">
                        {{ slotProps.data.address }}
                      </template>
                    </Column>
                    <Column field="price" header="Hind" sortable>
                      <template #body="slotProps">
                        {{ slotProps.data.actualPrice | splitNumber }} €
                      </template>
                    </Column>
                    <Column field="serviceFee" header="Teenustasu" sortable>
                      <template #body="slotProps">
                        {{ slotProps.data.actualServiceFee | splitNumber }} €
                      </template>
                    </Column>
                    <Column field="status" headerStyle="width:14%" header="Status">
                      <template #body="slotProps">
                        <p style="word-wrap: break-word">{{ slotProps.data.status?.name }}</p>
                      </template>
                    </Column>
                    <Column field="areas" header="Valdkonnad">
                      <template #body="slotProps">
                        {{ slotProps.data.areas }}
                      </template>
                    </Column>
                    <Column field="client_name" header="Kliendi nimi">
                      <template #body="slotProps">
                        {{ slotProps.data.client.name }}
                      </template>
                    </Column>
                    <Column field="client_phone" header="Kliendi telefon">
                      <template #body="slotProps">
                        {{ slotProps.data.client.phoneCode ? '+' + slotProps.data.client.phoneCode : '' }} {{ slotProps.data.client.phone }}
                      </template>
                    </Column>

                    <template #expansion="slotProps">
                      <div class="project-users-subtable bg-gray-200 p-3 rounded">

                        <div class="flex flex-wrap justify-between">
                          <div class="w-full md:w-1/2 lg:w-1/2">
                            <div>
                              <span class="font-semibold">Pindala:</span> {{ slotProps.data.size }}
                            </div>
                            <div>
                              <span class="font-semibold">Lisamise kuupäev:</span> {{ slotProps.data.createdAt }}
                            </div>
                            <div>
                              <span class="font-semibold">Pakutud hind:</span> {{ slotProps.data.estimatedPrice | splitNumber }} €
                            </div>
                            <div>
                              <span class="font-semibold">Pakutud hinna teenustasu:</span> {{ slotProps.data.estimatedServiceFee | splitNumber }} €
                            </div>
                          </div>
                          <div class="w-full md:w-1/2 lg:w-1/2">
                            <div>
                              <span class="font-semibold">Deponeeritud:</span>
                              <input-number
                                  placeholder=" "
                                  v-model="slotProps.data.deposit"
                                  :use-grouping="false"
                                  currency="EUR"
                                  class="pl-3"
                                  @input="updateDeposit(slotProps.data.id, slotProps.data.deposit)"/>
                              €
                            </div>
                            <div>
                              <span class="font-semibold">Deponeerimata:</span> {{ slotProps.data.actualPrice - slotProps.data.deposit | splitNumber }} €
                            </div>
                            <div class="pt-3">
                              <button class="text-white uppercase bg-blue-400 btn btn-sm" @click="sendDepositEmails(slotProps.data.id)">
                                Saada deponeerimise emailid
                              </button>
                            </div>
                          </div>
                        </div>
                        <h5 class="mb-5 text-xl font-semibold pt-3">Spetsialistid projektis {{slotProps.data.number}}</h5>
                        <DataTable :value="slotProps.data.extra">
                          <Column field="id" headerStyle="width:8%" header="ID"></Column>
                          <Column field="name" header="Nimi"></Column>
                          <Column field="status" header="Status">
                            <template #body="slotProps">
                              {{ slotProps.data.status.name }}
                            </template>
                          </Column>
                          <Column field="createdAt" header="Lisatud">
                            <template #body="slotProps">
                              {{ formatDate(slotProps.data.createdAt) }}
                            </template>
                          </Column>
                          <Column field="area" header="Valdkond">
                          </Column>
                          <Column field="phases" header="Etapid"></Column>
                          <Column field="price" header="Maksumus">
                            <template #body="slotProps">
                              {{ slotProps.data.price ? slotProps.data.price + ' €' : '' }}
                            </template>
                          </Column>
                        </DataTable>
                      </div>
                    </template>
                  </DataTable>

                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import {getAllProjects, getAllProjectUsers, updateDeposit, sendDepositEmails} from "@/store/admin.api";

export default {
    name: 'AdminProjects',
    components: {
        AppLayout
    },
    data() {
        return {
            loading: false,
            projects: null,
            expandedRows: []
        };
    },
    methods: {
      onRowExpand(event) {
        this.loading = true;
        getAllProjectUsers(event.data.id).then((resp) => {
          event.data.extra = resp.data;
          this.loading = false;
        }, () => {
          this.showToast('Projekti spetsialistide laadimine ebaõnnestus', 'error');
          this.loading = false;
        })

      },
      updateDeposit(projectId, deposit) {
        updateDeposit(projectId, deposit).then(() => {
          this.showToast('Deponeerimine õnnestus', 'success');
        }, () => {
          this.showToast('Deponeerimine ebaõnnestus', 'error');
        })
      },
      sendDepositEmails(projectId) {
        sendDepositEmails(projectId).then(() => {
          this.showToast('Emailide saatmine õnnestus', 'success');
        }, () => {
          this.showToast('Emailide saatmine ebaõnnestus', 'error');
        });
      },
      formatDate(apiDate) {
        const [year, month, day] = apiDate;

        return (
            year + '.' +
            String(month).padStart(2, '0') + '.' +
            String(day).padStart(2, '0')
        );
      }
    },
    async mounted() {
        this.loading = true;
        this.projects = [];
        getAllProjects().then((resp) => {
          this.projects = resp.data;
          this.loading = false;
        }, () => {
          this.loading = false;
        });
    },
}
</script>
